import React, { useEffect, useState } from "react";
import Dropdown, {
  dropdownTypes,
} from "@visiblethread/react-components/dist/components/Dropdown";
import infoIcon from "icons/info-new-rows.svg";
import Button, {
  buttonVariants,
} from "@visiblethread/react-components/dist/components/Button";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import { showModal } from "slices/app/actions/modals";
import { modalTypes } from "constants/types";

const options = [
  { content: <span>Never</span> },
  { content: <span>30</span> },
  { content: <span>60</span> },
  { content: <span>90</span> },
  { content: <span>120</span> },
  { content: <span>300</span> },
];

const showErrorMessage = (error) => (
  <span className={`input__error__message ${error !== "" ? "show" : ""}`}>
    {error}
  </span>
);

const AuthenticationUsernamePassword = ({ enabled }) => {
  const isUsernamePassword = useSelector(
    (state) => state.systemAdmin.isUsernamePassword
  );
  const expiryDays = useSelector((state) => state.systemAdmin.passwordExpiry);
  const dispatch = useDispatch();
  let matchingOption = options.find((option) => {
    return option.content.props.children === expiryDays;
  });

  const [password, setPassword] = useState();
  const [passwordError, setPasswordError] = useState("");
  const [dropdownSelected, setDropdownSelected] = useState(matchingOption);

  const otp = () => (
    <div className="authentication__content__body__username_password__otp">
      <header className="subtitle">One time password</header>
      <label
        htmlFor="authentication__content__body__username_password__otp-password"
        className="authentication__content__body__username_password__otp-label"
      >
        <span data-title="The password must be at least 8 characters long and contain at least 1 letter and 1 number." />
        <input
          type="password"
          id="authentication__content__body__username_password__otp-password"
          placeholder="Add a password"
          value={password}
          autoComplete="off"
          onChange={(e) => setPassword(e.target.value)}
          className={passwordError !== "" ? "input__error" : ""}
        />
        {showErrorMessage(passwordError)}
      </label>
      <div className="authentication__content__body__username_password__info">
        <span>
          <img src={infoIcon} alt="password info" /> Switching to VisibleThread
          Propriety Authentication will require a Temporary Password for each
          user.
        </span>
      </div>
    </div>
  );

  const expiry = () => (
    <div className="authentication__content__body__username_password__expiry">
      <header className="subtitle">Password Expiry</header>
      <span>
        Set period of time. In which the users will automatically be requested
        to change their password.
      </span>
      <span className="authentication__content__body__username_password__expiry__dropdown">
        <Dropdown
          type={dropdownTypes.simple}
          propsObject={{
            options,
            dropdownSelected,
            setDropdownSelected,
          }}
        />
      </span>
    </div>
  );

  const buttonDisabled = () =>
    (!isUsernamePassword &&
      (!password || password?.length === 0 || passwordError !== "")) ||
    (isUsernamePassword &&
      dropdownSelected.content.props.children === expiryDays);

  useEffect(() => {
    const timeOutId = setTimeout(() => {
      if (password?.length < 8 && password?.length > 0) {
        setPasswordError("The minimum length for this field is 8");
      } else if (password?.length && !/\d+/.test(password)) {
        setPasswordError("Password must contain at least one digit");
      } else {
        setPasswordError("");
      }
    }, 500);
    return () => clearTimeout(timeOutId);
  }, [password]);

  useEffect(() => {
    matchingOption = options.find((option) => {
      return option.content.props.children === expiryDays;
    });
    setDropdownSelected(matchingOption);
  }, [expiryDays]);

  return (
    <div className="authentication__content__body__username_password">
      {enabled ? null : (
        <div className="authentication__content__body__username_password__disabled" />
      )}
      <div className="authentication__content__body__username_password__title">
        <header className="title">VisibleThread Authentication Settings</header>
        <span>User credentials are stored in the VisibleThread database.</span>
        <span>Passwords are salted/hashed using BCrypt.</span>
      </div>
      {isUsernamePassword ? expiry() : otp()}
      <div className="authentication__content__body__username_password__button">
        <Button
          onClick={() => {
            dispatch(
              showModal(modalTypes.ENABLE_USERNAME_PASSWORD, {
                isUsernamePassword,
                expiry: dropdownSelected.content.props.children,
                password,
              })
            );
          }}
          variant={buttonVariants.primary}
          content="Save Settings"
          disabled={buttonDisabled()}
        />
      </div>
    </div>
  );
};

AuthenticationUsernamePassword.propTypes = {
  enabled: PropTypes.bool.isRequired,
};

export default AuthenticationUsernamePassword;
